<div class="flex w-full align-items-center justify-content-center">
	<i class="pi cm-info text-4xl mr-3"></i>
	<p>{{ 'MTMA_INFO_GENERIC_ENTRY' | translate }}<br>
	{{ 'MTMA_HOWTO_NOTIFYMAIL' | translate }}</p>
</div>
<div class="grid mt-3">
	<div class="col-12 flex justify-content-center">
		<button type="button" pButton pRipple (click)="closeDialog();"
			label="{{ 'CLOSE' | translate }}"
			styleClass="p-dialog p-dialog-footer"
			class="p-button-secondary mx-1">
		</button>
	</div>
</div>